<template>
    <div>
        <v-switch
            class="mt-0"
            label="Enable Test Delivery/Payment Method"
            hide-details
            color="primary"
            :value="enabled"
            @change="onChange"
        ></v-switch>
        <p class="subtitle-2 pl-11" style="color: rgba(0,0,0,.6);">
            Turn on to enable Kaoshi test payment method
        </p>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            enabled: 'testPaymentEnabled'
        })
    },
    methods: {
        async onChange(value) {
            try {
                this.$emit('loading');
                const response = await Vue.backendApi()
                    .user(this.$store.state.user.id)
                    .storeKaoshiTestPaymentSettings({
                        enable_kaoshi_test_payment: !!value,
                    });
                if (response.data.hasOwnProperty('enable_kaoshi_test_payment')) {
                    this.$store.commit('storeTestPaymentStatus', response.data.enable_kaoshi_test_payment)
                }
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error saving test payment setting',
                    text: err,
                });
            } finally {
                this.$emit('loaded');
            }
        },
    },
};
</script>

<style scoped>
.v-input.v-input--switch >>> .v-input__control label {
    color: #000 !important;
}
</style>
